import React, { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';

import Header from './Header';
import ThemaList from './ThemaList';
import StageList from './StageList';
import { TYPE } from '../../../constant';
import { mathpidLogAPICall } from '../../../redux/logData';
import { useUserInfo } from '../../../hooks';
import useAmplitude from '../../../hooks/useAmplitude';

function TopicLearningV2() {
  const { info } = useUserInfo();
  const { setAmplitudeLog } = useAmplitude();
  const logDispatch = useDispatch();
  const [thmaCd, setThmaCd] = useState(null);
  const [moveScroll, setScroll] = useState(false);
  const deviceInfo = useSelector(state => state.deviceInfo);

  useEffect(() => {
    console.log("***** 주제학습 페이지")
    logDispatch(mathpidLogAPICall({
      verbId: 'accessed',
      objectId: 'screen',
      screenVersion: 'screenCode',
      screenCode: 'scr_0001_0002'
    }));
    setAmplitudeLog({ eventCategory: 'app_usage', eventName: '주제학습메인 조회', isHackleSend: true, });
  }, []);

  const onScroll = () => {

    let lastScrollTop = 100;
    let spaceHeight = deviceInfo.type === TYPE.DEVICE.PHONE ? 60 : 120;
    let cont = document.getElementById('scrolling-cont');
    let box = document.getElementById('scrollingBox');

    if(box.scrollTop > lastScrollTop){
      if (cont.clientHeight > box.clientHeight + spaceHeight) {
        setScroll(true);
      }
    }else{
      if(box.scrollTop === 0){
        setScroll(false);
      }
    }
  };

  const onChangeThmaCd = useCallback((cd) => {
    setThmaCd(cd);
  }, [thmaCd]);

  return (
    <React.Fragment>
      <div className={clsx(
        "header_top",
        info.channelCode === TYPE.CHANNEL.GLOBAL01 ? 'gb' : 'gm',
      )}>
        <div className="inner">
          <Header />
        </div>
      </div>
      <div className={clsx(
        "layout-def layout-lc layout-sl",
        info.channelCode === TYPE.CHANNEL.GLOBAL01 && 'gb'
      )}>
        <ThemaList
          moveScroll={moveScroll}
          onChangeThmaCd={onChangeThmaCd}
        />
        {
          thmaCd && (
            <StageList
              thmaCd={thmaCd}
              onScroll={onScroll}
            />
          )
        }
      </div>
    </React.Fragment>
  );
}

export default TopicLearningV2;